import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { TextInput } from '@moonpig/launchpad-forms'
import { Box } from '@moonpig/launchpad-components'
import { FormStep, ValidationError } from './types'
import { useAuthenticationLocaleText } from '../../text-localisation'
import { restrictInput } from './utils'

const basicEmailRegexPattern = /^\S+@\S+\.\S+$/

export const EmailField: React.FC<{
  validationErrors: ValidationError[]
  onChange: () => void
}> = ({ validationErrors, onChange }) => {
  const localiseText = useAuthenticationLocaleText()
  const { control, getValues } = useFormContext()
  const { formStep } = getValues()

  const getRules = () => {
    return {
      required: {
        message: localiseText('auth_wizard.email_error'),
        value: true,
      },
      pattern: {
        message: localiseText('auth_wizard.email_error'),
        value: basicEmailRegexPattern,
      },
    }
  }

  const internalOnChange = (
    onFieldChange: (...event: React.ChangeEvent<HTMLInputElement>[]) => void,
  ) => {
    onChange()
    return restrictInput(onFieldChange, 'email')
  }

  const canShowEmailField =
    formStep !== FormStep.CODE_LOGIN && formStep !== FormStep.CODE_RECOVERY

  return (
    <Box display={canShowEmailField ? '' : 'none'}>
      <Controller
        control={control}
        name="email"
        rules={getRules()}
        render={({
          field: { name, value, onChange: onFieldChange },
          fieldState: { error },
        }) => (
          <TextInput
            mb={6}
            name={name}
            value={value}
            onChange={e => internalOnChange(onFieldChange)(e)}
            type="email"
            label={localiseText('auth_wizard.email_label')}
            error={!!(error || validationErrors.find(e => e.field === 'email'))}
            helperText={
              error?.message ??
              validationErrors.find(e => e.field === 'email')?.message
            }
            autoCapitalize="off"
            autoCorrect="off"
            spellCheck="false"
            autoComplete="email"
            disabled={
              formStep === FormStep.ACCOUNT_LINKING ||
              formStep === FormStep.SOCIAL_LOGIN
            }
          />
        )}
      />
    </Box>
  )
}
